// Contact / wholesale forms: interest chips → hidden field; scroll the success/error state into view after the post.
document.querySelectorAll('[data-cl-contact]').forEach((f) => {
  const hidden = f.querySelector('[data-chips-value]');
  f.addEventListener('click', (e) => {
    const c = e.target.closest('[data-chip]'); if (!c) return;
    c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed') !== 'true')); c.classList.toggle('on');
    if (hidden) hidden.value = [...f.querySelectorAll('[data-chip][aria-pressed="true"]')].map((x) => x.dataset.chip).join(', ');
  });
  const msg = f.querySelector('.ws-done, .form-err');
  if (msg) requestAnimationFrame(() => msg.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
});
